<template>
    <div>
        <div>
            <el-form ref="form1" v-model="lessonBase">
                <el-row style="margin-top: 10vh;width: 100%">
                    <el-col :span="12">
                        <el-form-item label="课程标题" style="float: left;width: 700px">
                            <el-input placeholder="标题" v-model="lessonBase.title" style="width: 600px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="课程链接">
                            <el-input placeholder="链接" v-model="lessonBase.lessonUrl" style="width:600px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="课程类型">
                            <el-select placeholder="课程类型" v-model="lessonBase.classType" style="width: 180px">
                                <el-option label="本期学习" value="本期学习"></el-option>
                                <el-option label="往期学习" value="往期学习"></el-option>
                                <el-option label="阅读频道" value="阅读频道"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item>
                            <el-upload
                                    class="upload-demo"
                                    accept="image/*"
                                    ref="upload"
                                    :data="pppss"
                                    :on-change="changeImg"
                                    :file-list="fileList"
                                    :on-remove="handleRemove"
                                    :auto-upload="false">
                                <el-button slot="trigger" type="primary">选取文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item>
                            <el-button style="margin-left: 10px;" type="success" @click="submitUpload">上传系统
                            </el-button>
                            <el-button type="primary" @click="getLessions">查询</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <el-divider></el-divider>
        <div>
            <el-table
                    class="show_table"
                    :row-style="{ height: '200px' }"
                    :data="tableData.data"
                    element-loading-text="加载中"
                    border>
                <el-table-column
                        label="图片"
                        width="200" height="200">
                    <template slot-scope="scope" style="width:200px;height:200px">
                        <el-image class="lesson-img"
                                  :src="'data:image/'+scope.row.imgType+';base64,'+scope.row.picSub">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                        label="课程编码"
                        width="120">

                    <template slot-scope="scope">
                        <span style="margin-left: 10px">{{scope.row.classId}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="课程标题"
                        width="150">
                    <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ scope.row.classTitle }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="课程类型"
                        width="300">
                    <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ scope.row.classType }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="课程URL"
                        width="300">
                    <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ scope.row.url }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="修改"
                        width="200">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">Edit
                        </el-button>
                        <el-button
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)">Delete
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 删除提示框 -->
            <el-dialog title="提示" :visible.sync="delVisible" width="300px" center>
                <div class="del-dialog-cnt">删除不可恢复，是否确定删除？</div>
                <span slot="footer" class="dialog-footer">
                <el-button @click="delVisible = false">取 消</el-button>
                <el-button type="primary" @click="this.deleteRow">确 定</el-button>
            </span>
            </el-dialog>
            <el-dialog title="编辑数据" :visible.sync="editVisible">
                <el-form :model="modifyForm">
                    <el-form-item label="标题" :label-width="modifyForm.formLabelWidth">
                        <el-input v-model="modifyForm.classTitle" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="课程类型" :label-width="modifyForm.formLabelWidth">
                        <el-select placeholder="课程类型" v-model="modifyForm.classtype" style="width: 180px">
                            <el-option label="本期学习" value="本期学习"></el-option>
                            <el-option label="往期学习" value="往期学习"></el-option>
                            <el-option label="阅读频道" value="阅读频道"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="url" :label-width="modifyForm.formLabelWidth">
                        <el-input v-model="modifyForm.classUrl" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="图片" :label-width="modifyForm.formLabelWidth">
                        <el-form-item>
                            <el-upload
                                    class="upload-demo"
                                    accept="image/*"
                                    ref="upload"
                                    :data="pppss1"
                                    :on-change="editChangeImg"
                                    :file-list="editFileList"
                                    :on-remove="handleRemove"
                                    :auto-upload="false">
                                <el-button slot="trigger" type="primary">选取文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editVisible=false">取 消</el-button>
                    <el-button type="primary" @click="this.editClass">确 定</el-button>
                </div>
            </el-dialog>
        </div>

    </div>
</template>


<script>
    // import {uploadLesson} from "@api/lesson";
    import {VUE_APP_API_URL} from "@utils";
    import {queryLessonList} from "@api/lesson";
    import {delLesson} from "@api/lesson";

    export default {
        name: "UploadImage",
        data() {
            return {
                tableData: {pageInfo: {pageNum: 1, pageRow: 10, rowNum: 1}, data: []},
                lessonBase: {
                    title: '',
                    classType: '',
                    lessonUrl: ''
                },
                editClassBase: {
                    title: '',
                    classType: '',
                    lessonUrl: '',
                    classId: '',
                },
                fileList: [],
                editFileList: [],
                pppss: {
                    srid: ""
                },
                pppss1: {
                    srid: ""
                },
                fileNames: [],
                editFileNames: [],
                delVisible: false,//删除提示弹框的状态
                editVisible: false,
                msg: "",//记录每一条的信息，便于取id
                delarr: [],//存放删除的数据
                classId: "",
                multipleSelection: [],//多选的数据
                modifyForm: {
                    formLabelWidth: '200px',
                    classTitle: '',
                    classId: '',
                    classtype: '',
                    classUrl: '',
                    classImg: '',
                },

            }
        },
        methods: {
            // 确定删除
            deleteRow() {
                var params = {
                    classId: this.classId
                }
                console.log(params)
                delLesson(params).then(res => {
                    if (res.count > 0) {
                        this.getLessions();
                        this.$message.success('删除成功')
                    }
                }).catch(error => {
                    console.log(error);
                    this.$message.error('删除失败')
                })
                this.delVisible = false;//关闭删除提示模态框
            },
            // selectFamRow(val) {
            //     console.log(val.pop())
            //     if (val.length > 1) {
            //         this.$refs.multipleFaTable.clearSelection();
            //         this.$refs.multipleFaTable.toggleRowSelection(val.pop());
            //     } else {
            //         this.multipleFaTable = val.pop()
            //     }
            //
            // },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            changeImg(file, fileList) {
                this.fileNames = fileList;
                console.log(this.fileNames);
            },
            editChangeImg(file, fileList) {
                this.editFileNames = fileList;
                console.log(this.editFileNames);
            },
            getLessions() {
                var arr = this;
                var params = {
                    classType: this.lessonBase.classType,
                    title: this.lessonBase.title,
                    pcOPhone:"add_class",
                }
                console.log("发起查询请求时间：");
                let time=this.getFormatDate();
                console.log(time)
                queryLessonList(params).then(response => {
                    console.log("结束查询请求时间：");
                    let time1=this.getFormatDate();
                    console.log(time1)
                    // let loading = this.$weui.loading("数据加载中");
                    // console.log( response.lessonList)
                    arr.tableData.data = response.lessonList;
                    // console.log(arr.tableData.data)
                    // loading.hide();
                });

                console.log("团课内容");
            },
            getFormatDate() {
                var date = new Date();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentDate = date.getFullYear() + "-" + month + "-" + strDate
                    + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
                return currentDate;
            },
            submitUpload() {
                let self = this
                let imgfile = new FormData();
                for (var i = 0; i < self.fileNames.length; i++) {
                    // files[i] = this.fileList[i].raw;
                    imgfile.append("files", self.fileNames[i].raw);
                }
                // console.log("文件长度",files.length);
                imgfile.append("lessonTitle", self.lessonBase.title);
                imgfile.append("classType", self.lessonBase.classType);
                imgfile.append("lessonUrl", self.lessonBase.lessonUrl);

                console.log("将要上传的文件：", imgfile.get("files"), self.lessonBase.classType);
                if (self.fileNames.length > 1 || self.fileNames.length === 0) {
                    self.$message.warning('每次只能上传一张图片！');
                } else if (self.lessonBase.title === "") {
                    self.$message.warning('请输入课程标题！');
                } else if (self.lessonBase.classType === "") {
                    self.$message.warning('请输入课程类型！');
                } else {
                    if (self.fileNames.length > 0) {
                        self.$axios({
                            url: `${VUE_APP_API_URL}/lesson/uploadLesson`,
                            method: "post",
                            data: imgfile,
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        }).then(function (res) {
                            console.log(res);
                            if (res.data.code) {
                                self.dialogNoteVisible = false;
                                self.$message.success('上传成功!');
                                self.getLessions();
                            } else {
                                self.$message.error('上传失败!');
                            }
                        }).catch(function (err) {
                            self.$message.error('网络请求异常!' + err);
                        });
                    } else {
                        self.$message.error('请选择要上传的材料!');
                    }
                    this.clearUploadedImage()
                }
            },
            clearUploadedImage() {
                this.$refs.upload.clearFiles();
            },
            handleEdit(index, row) {
                console.log(row.classId)
                this.modifyForm.classtype = row.classType;
                this.modifyForm.classTitle = row.classTitle;
                this.modifyForm.classId = row.classId;
                this.modifyForm.classUrl = row.url;
                this.editVisible = true
            },
            handleDelete(index, row) {
                console.log(row.classId);
                this.idx = index;
                this.msg = row;//每一条数据的记录
                this.classId = row.classId;//把单行删除的每条数据的id添加进放删除数据的数组
                this.delVisible = true;
            },
            editClass() {
                let self = this
                let imgfile = new FormData();
                for (var i = 0; i < self.editFileNames.length; i++) {
                    // files[i] = this.fileList[i].raw;
                    imgfile.append("files", self.editFileNames[i].raw);
                }
                // console.log("文件长度",files.length);
                imgfile.append("lessonTitle", self.modifyForm.classTitle);
                imgfile.append("classType", self.modifyForm.classtype);
                imgfile.append("lessonUrl", self.modifyForm.classUrl);
                imgfile.append("classId", self.modifyForm.classId);
                console.log("将要上传的文件：", imgfile.get("files"), self.modifyForm.classtype);
                if (self.modifyForm.classTitle === "") {
                    self.$message.warning('请输入课程标题！');
                }  else if (self.modifyForm.classtype === "") {
                    self.$message.warning('请输入课程类型！');
                } else {
                    self.$axios({
                        url: `${VUE_APP_API_URL}/lesson/editLesson`,
                        method: "post",
                        data: imgfile,
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }).then(function (res) {
                        console.log(res);
                        if (res.data.code) {
                            self.editVisible = false;
                            self.$message.success('修改成功!');
                            self.getLessions();
                        } else {
                            self.$message.error('修改失败!');
                        }
                    }).catch(function (err) {
                        self.$message.error('网络请求异常!' + err);
                    });
                    this.clearUploadedImage()
                }
            }
        },
    }
</script>

<style scoped>
    .show_table {
        position: relative;
        width: 100%;
        overflow: auto;
        height: 100%
    }

</style>
